export default "__VITE_ASSET__C_E6nf26__"